export const modalToSelectFavoriteCompany = {
    titleWithTheme: 'Favorite companies saved for "{{theme}}"',
    title: 'Favourite Company List',
    tableHeader1: 'Company Name'
}
